import CountrySelectFlag from "./CountrySelectFlag";
import useCountryValues from "../../../hooks/useCountryNames";
import React, { useMemo } from "react";
import { useConfig } from "../../../contexts";
import AnimatedRoundedSelect from "../../../components/AnimatedRoundedSelect/AnimatedRoundedSelect";
import { useTranslationV3 } from "../../../i18nV3/useTranslationV3";

interface Props {
  value: string;
  onChange: (value: string) => void;
  hasError?: boolean;
}

const AnimatedCountrySelect = ({ value, onChange, hasError }: Props) => {
  const { countries } = useCountryValues();
  const config = useConfig();
  const { t } = useTranslationV3();

  const options = useMemo(
    () =>
      Object.entries(
        countries.getNames(config.defaultLang, { select: "official" })
      ).map(([value, label]) => ({
        label,
        value,
      })),
    [config.defaultLang, countries]
  );

  const optionsWithIcon = useMemo(() => {
    return options.map((o) => {
      return {
        ...o,
        leftIcon: <CountrySelectFlag countryCode={o.value} />,
      };
    });
  }, [options]);

  return (
    <AnimatedRoundedSelect
      options={optionsWithIcon}
      placeholder={t("tix_ui_country_select_placeholder")}
      value={value}
      leftIcon={!!value ? <CountrySelectFlag countryCode={value} /> : undefined}
      isSearchable
      onChange={onChange}
      hasError={hasError}
      distinctPlaceholder
    />
  );
};

export default AnimatedCountrySelect;
